module.exports = __webpack_public_path__ + "img/bgc5.9f55d450.png";